import React from 'react'
import BellIcon from '../../Icons/roofers/bell-icon.svg'
import HomeIcon from '../../Icons/roofers/home-icon.svg'
import LaunchlIcon from '../../Icons/roofers/launch-icon.svg'
import SectionHeading from './SectionHeading'

const defaultHeading = 'How It Works'

const defaultEdges = {
    topLeft: {
        src: '/assets/roofers/roofers-edge-3.png',
        alt: 'Decorative postcard top-left',
    },
}

const defaultSteps = [
    {
        title: 'Target the Right Homes',
        body: 'Use storm-path data and homeowner lists to reach the neighborhoods that need you most.',
        icon: <HomeIcon />,
    },
    {
        title: 'Design That Demands Attention',
        body: 'Bold postcards, personalized letters, and handwritten-style notes make your message impossible to ignore.',
        icon: <BellIcon />,
    },
    {
        title: 'Launch & Track',
        body: 'We print, ship, and deliver in as little as two days—while QR and call tracking show you real results.',
        icon: <LaunchlIcon />,
    },
]

function StepCard({ title, body, icon }) {
    return (
        <div className="rounded-xl border border-black shadow-sm">
            <div className="px-6 py-7 sm:px-7 sm:py-8 text-center">
                {icon ? (
                    <div className="flex justify-center mb-4 text-olm">
                        {icon}
                    </div>
                ) : null}
                <div
                    className="text-xl font-bold text-black"
                    dangerouslySetInnerHTML={{ __html: title }}></div>
                <p className="mt-3 text-black font-normal text-base sm:text-xl">
                    {body}
                </p>
            </div>
        </div>
    )
}

export default function HowItWorks(props) {
    const heading = props?.heading || defaultHeading
    const steps =
        Array.isArray(props?.steps) && props.steps.length > 0
            ? props.steps
            : defaultSteps
    const edges = props?.edges || defaultEdges

    return (
        <section className="relative z-22 overflow-visible overflow-x-hidden bg-gray-50">
            {/* Decorative edge images (optional) */}
            {edges?.topLeft?.src ? (
                <div className="hidden lg:block absolute -top-12 -right-2 z-30 pointer-events-none">
                    <img
                        src={edges.topLeft.src}
                        alt={edges.topLeft.alt || 'Decorative postcard'}
                        className="w-full h-auto drop-shadow-2xl"
                    />
                </div>
            ) : null}

            <div className="relative z-10 container mx-auto px-4 py-14 sm:py-16 lg:py-20">
                <SectionHeading>{heading}</SectionHeading>

                <div className="mt-8 sm:mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
                    {steps.map((step, idx) => (
                        <StepCard key={`${step.title}-${idx}`} {...step} />
                    ))}
                </div>
            </div>
        </section>
    )
}
